export default __webpack_public_path__ + "static/media/chariot.1fbe9c59.png";